import { Text, View } from '@react-pdf/renderer'
import type { MarkdownBlock } from 'features/knowledgeDocumentViewer/artifacts/freeformMarkdown'
import React from 'react'

import { renderInline } from './PdfInline'
import type { PdfStyles } from './PdfPrimitives'
import { PdfTable } from './PdfTable'

export function PdfBlock({
  block,
  styles,
}: {
  block: MarkdownBlock
  styles: PdfStyles
}): React.ReactElement {
  if (block.type === 'heading') {
    return (
      <Text style={styles.subHeading} minPresenceAhead={24}>
        {renderInline(styles, block.children)}
      </Text>
    )
  }
  if (block.type === 'paragraph') {
    return (
      <Text style={styles.paragraph}>
        {renderInline(styles, block.children)}
      </Text>
    )
  }
  if (block.type === 'blockquote') {
    return (
      <View style={styles.blockquote}>
        <Text style={styles.blockquoteText}>
          {renderInline(styles, block.children)}
        </Text>
      </View>
    )
  }
  if (block.type === 'list') {
    return (
      <View style={styles.list}>
        {block.items.map((item, index) => (
          <View key={index} style={styles.listItem}>
            <Text style={styles.listMarker}>
              {block.ordered ? `${block.start + index}.` : '•'}
            </Text>
            <Text style={styles.listBody}>{renderInline(styles, item)}</Text>
          </View>
        ))}
      </View>
    )
  }
  return <PdfTable block={block} styles={styles} />
}
